import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./Debtor/Main";
import Form from "./Debtor/Form";

// Utils
import { getData, getAlert, getDataWithComp } from "../../../utils/SamuiUtils";
import { InitialDataDebtor } from "../../../model/InitialData/InitialDataDebtor";

const Debtor = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [dataARtype, setDataARtype] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState(InitialDataDebtor());
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime(); // เรียกใช้งาน fetchRealtime เพื่อโหลดข้อมูลเมื่อ component โหลดครั้งแรก
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      // ดึงข้อมูลจาก Tb_Set_AR ทั้งหมด
      const masterList = await getDataWithComp(
        "View_Set_AR",
        `ORDER BY AR_Code`
      );
      const dataARtype = await getData(
        "Tb_Set_ARType",
        `1=1 AND Comp_Id = ${localStorage.getItem("company")}`
      );

      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }
      if (dataARtype && dataARtype.length > 0) {
        setDataARtype(dataARtype);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    setMode("U");
    setFormData({
      ar_id: item.Ar_Id,
      comp_id: window.localStorage.getItem("company"),
      ar_code: item.Ar_Code,
      ar_name: item.Ar_Name,
      ar_type: item.ARType_Name,
      ar_shortname: item.Ar_ShortName,
      ar_taxno: item.Ar_TaxNo,
      ar_add1: item.Ar_Add1,
      ar_add2: item.Ar_Add2,
      ar_add3: item.Ar_Add3,
      ar_province: item.Ar_Province,
      ar_zipcode: item.Ar_Zipcode,
      ar_contact1: item.Ar_Contact,
      ar_contact2: item.Ar_Contact2,
      ar_tel1: item.Ar_Tel1,
      ar_tel2: item.Ar_Tel2,
      ar_group: item.Ar_Group,
      ar_refsalecode: item.Ar_RefSaleCode,
      ar_area: item.Ar_Area,
      ar_status: item.Ar_Status,
      ar_credit: item.Ar_Credit,
      ar_vat: item.Ar_Vat,
      ar_discount: item.Ar_Discount,
      ar_branch: item.Ar_Branch,
      ar_bt_name: item.Ar_BT_Name,
      ar_addlat: item.AR_ADDLAT,
      ar_addlan: item.AR_ADDLAN,
      ar_refsaleName: item.AR_RefSaleName,
      ar_credit_term: item.AR_Credit_Term,
      ar_credit_limit: item.AR_Credit_Limit,
    });
    setSelectedData(item);
  };

  return (
    <div className="Creditor">
      <button
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        className="btn btn-toggle-sidebar"
        style={{
          position: "fixed",
          top: "1rem",
          left: isSidebarOpen ? "190px" : "-15px",
          zIndex: 1001,
          background: "transparent",
          border: "none",
          color: "#EF6C00",
          fontSize: "20px",
        }}
      >
        {isSidebarOpen ? "✖" : "☰"}
      </button>
      <div className="wrapper">
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <div
          className={`main-panel ${
            isSidebarOpen ? "sidebar-open" : "sidebar-closed"
          }`}
        >
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลลูกหนี้"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลลูกหนี้"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                  dataARtype={dataARtype}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Debtor;
